export const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1400,
  height: 600,
  bgcolor: 'background.paper',
  pt: 2,
  px: 4,
  pb: 3,
  borderRadius: '8px',
};

// The folder modal above is a full-width workspace; the delete confirmation is a small
// decision box, so it gets its own dimensions rather than inheriting that footprint.
export const deleteConfirmStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 520,
  maxHeight: '80vh',
  overflowY: 'auto' as const,
  bgcolor: 'background.paper',
  pt: 2,
  px: 4,
  pb: 3,
  borderRadius: '8px',
};
